var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"damagesview"}},[_c('damages',{attrs:{"damages":_vm.damages}}),_c('create-damage',{on:{"create-damage":_vm.createDamage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }